// src/auth/authConfig.js
import { LogLevel } from '@azure/msal-browser';

/**
 * MSAL configuration for Microsoft Entra ID authentication.
 *
 * Before deploying, replace the placeholders below with your actual
 * Azure App Registration values:
 *   - clientId:    Application (client) ID from the Azure portal
 *   - authority:   https://login.microsoftonline.com/<YOUR_TENANT_ID>
 *   - redirectUri: The URI registered in Azure for redirect after login
 */
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID || 'YOUR_CLIENT_ID',
        authority: process.env.REACT_APP_AZURE_AUTHORITY || 'https://login.microsoftonline.com/YOUR_TENANT_ID',
        redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin,
        postLogoutRedirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Warning,
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        break;
                    case LogLevel.Warning:
                        console.warn(message);
                        break;
                    default:
                        break;
                }
            },
        },
    },
};

// Scopes requested during login
export const loginRequest = {
    scopes: ['User.Read'],
};
